// extracted by mini-css-extract-plugin
module.exports = {"supply":"ItemDetail_supply__YjFIJ","ownerButtons":"ItemDetail_ownerButtons__3JbBf"};